"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
        noResultsText: 'No matching records found',
        loadingText: 'Loading items...'
    },
    dataTable: {
        itemsPerPageText: 'Rows per page:',
        ariaLabel: {
            sortDescending: ': Sorted descending. Activate to remove sorting.',
            sortAscending: ': Sorted ascending. Activate to sort descending.',
            sortNone: ': Not sorted. Activate to sort ascending.'
        },
        sortBy: 'Sort by'
    },
    dataFooter: {
        itemsPerPageText: 'Items per page:',
        itemsPerPageAll: 'All',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        firstPage: 'First page',
        lastPage: 'Last page',
        pageText: '{0}-{1} of {2}'
    },
    datePicker: {
        itemsSelected: '{0} selected'
    },
    noDataText: 'Không có dữ liệu',
    carousel: {
        prev: 'Previous visual',
        next: 'Next visual',
        ariaLabel: {
            delimiter: 'Carousel slide {0} of {1}'
        }
    },
    calendar: {
        moreEvents: '{0} more'
    },
    fileInput: {
        counter: '{0} files',
        counterSize: '{0} files ({1} in total)'
    },
    timePicker: {
        am: 'AM',
        pm: 'PM'
    }
};
exports.default = _default;
//# sourceMappingURL=en.js.map
